import React, { useContext, useEffect } from "react";

import { useBanner } from "../../providers/BannerProvider/BannerProvider";
import FlexPackDetailsContext from "../../context/FlexPackDetails/FlexPackDetails";

import { Banner } from "../Banner";

export default function FlexPackBanner() {
  const { setObj, setPublishDate, setStart, setEnd } = useBanner();

  const { flexPack, flexPackStart, flexPackEnd, flexPackVisibility } =
    useContext(FlexPackDetailsContext);

  useEffect(() => {
    setObj(flexPack);
    setPublishDate(flexPackVisibility);
    setStart(flexPackStart);
    setEnd(flexPackEnd);
  }, [flexPack, flexPackStart, flexPackEnd, flexPackVisibility]);

  return (
    <>
      <Banner />
    </>
  );
}
